import { render } from "./Telegram.vue?vue&type=template&id=27a71f4b&lang=pug"
import script from "./Telegram.vue?vue&type=script&lang=js"
export * from "./Telegram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__